<app-pageheader [Parent]="this">
    <add-button AddRoute="/integrations/flowbird/new/edit"></add-button>
  </app-pageheader>
  
  <app-datalistview [Columns]="Columns" [ShowMap]="false" ApiUrl="integrations/flowbird/configurations/search"
    [AllowEdit]="true" EditUrl="/integrations/flowbird/:id">
    <app-filter-set>
      <div app-search-filter></div>
      <div app-search-button></div>
    </app-filter-set>
  </app-datalistview>

